/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscogsSearchArtistsInnerExternalIdsInner
 */
export interface DiscogsSearchArtistsInnerExternalIdsInner {
    /**
     * 
     * @type {string}
     * @memberof DiscogsSearchArtistsInnerExternalIdsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsSearchArtistsInnerExternalIdsInner
     */
    source: string;
}

/**
 * Check if a given object implements the DiscogsSearchArtistsInnerExternalIdsInner interface.
 */
export function instanceOfDiscogsSearchArtistsInnerExternalIdsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function DiscogsSearchArtistsInnerExternalIdsInnerFromJSON(json: any): DiscogsSearchArtistsInnerExternalIdsInner {
    return DiscogsSearchArtistsInnerExternalIdsInnerFromJSONTyped(json, false);
}

export function DiscogsSearchArtistsInnerExternalIdsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscogsSearchArtistsInnerExternalIdsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'source': json['source'],
    };
}

export function DiscogsSearchArtistsInnerExternalIdsInnerToJSON(value?: DiscogsSearchArtistsInnerExternalIdsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'source': value.source,
    };
}

